import { useParams } from "react-router-dom";
import { Spin, Tabs, List } from "antd";
import { getInstitution } from "../../services/institutionService";
import { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";

import toast from "react-hot-toast";
import OverviewTab from "../../components/Profile/OverviewTab";
import PageHeading from "../../components/PageElements/PageHeading";
import AccreditationsTab from "../../components/Profile/AccreditationsTab";
import StaffTab from "../../components/Profile/StaffTab";
import MilestonesTab from "../../components/Profile/MilestonesTab";
import NotableAlumni from "../../components/Profile/NotableAlumni";
import PartnersTab from "../../components/Profile/PartnersTab";
import PublicationsTab from "../../components/Profile/PublicationsTab";
import ResearchCentresTab from "../../components/Profile/ResearchCentresTab";
import FacultiesTab from "../../components/Profile/FacultiesTab";
import TechnologyInitiativeTab from "../../components/Profile/TechnologyInitiativeTab";
import CampusesTab from "../../components/Profile/CampusesTab";
import AcademicProgramsTab from "../../components/Profile/AcademicProgramsTab";
import AffiliationsTab from "../../components/Profile/AffiliationsTab";
import AwardsTab from "../../components/Profile/AwardsTab";
import FacilitiesTab from "../../components/Profile/FacilitiesTab";
import StudentStatsTab from "../../components/Profile/StudentStatsTab";
import StaffStatsTab from "../../components/Profile/StaffStatsTab";
import GraduationStatsTab from "../../components/Profile/GraduationStatsTab";

const InstitutionProfile = () => {
  const [institution, setInstitution] = useState(null);
  const [loading, setLoading] = useState(false);

  const { id: institutionID } = useParams();

  useEffect(() => {
    if (institutionID) {
      loadInstitution(institutionID);
    }
  }, [institutionID]);

  const loadInstitution = async (id) => {
    setLoading(true);
    try {
      const { data } = await getInstitution(id);
      setInstitution(data.data);
    } catch (error) {
      const { response } = error;
      toast.error(
        response?.data?.error || "Failed to load Institution, try again!"
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading || !institution) {
    return (
      <div className="flex justify-center items-center h-96">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
      </div>
    );
  }

  const renderList = (items, renderItem) => (
    <List
      itemLayout="vertical"
      dataSource={items}
      renderItem={renderItem}
      bordered
    />
  );

  const tabItems = [
    {
      key: "overview",
      label: "Overview",
      children: <OverviewTab institution={institution} />,
    },

    {
      key: "campuses",
      label: "Campuses",
      children: <CampusesTab institution={institution} />,
    },
    {
      key: "faculties",
      label: "Faculties",
      children: <FacultiesTab institution={institution} />,
    },

    {
      key: "academic-programs",
      label: "Academic Programs",
      children: <AcademicProgramsTab institution={institution} />,
    },
    {
      key: "student-stats",
      label: "Student Statistics",
      children: <StudentStatsTab institution={institution} />,
    },
    {
      key: "staff-stats",
      label: "Staff Statistics",
      children: <StaffStatsTab institution={institution} />,
    },
    {
      key: "grad-stats",
      label: "Graduation Statistics",
      children: <GraduationStatsTab institution={institution} />,
    },
    {
      key: "staff",
      label: "Staff",
      children: <StaffTab institution={institution} />,
    },
    {
      key: "accreditations",
      label: "Accreditations",
      children: <AccreditationsTab institution={institution} />,
    },

    {
      key: "affiliations",
      label: "Affiliations",
      children: <AffiliationsTab institution={institution} />,
    },

    {
      key: "alumni",
      label: "Notable Alumni",
      children: <NotableAlumni institution={institution} />,
    },
    {
      key: "partners",
      label: "Partnerships",
      children: <PartnersTab institution={institution} />,
    },
    {
      key: "publications",
      label: "Publications",
      children: <PublicationsTab institution={institution} />,
    },
    {
      key: "facilities",
      label: "Specialized Facilities",
      children: <FacilitiesTab institution={institution} />,
    },
    {
      key: "research-centres",
      label: "Research Centres",
      children: <ResearchCentresTab institution={institution} />,
    },
    {
      key: "tech-initiatives",
      label: "Projects & Innovations / STEAM",
      children: <TechnologyInitiativeTab institution={institution} />,
    },

    {
      key: "milestones",
      label: "Milestones",
      children: <MilestonesTab institution={institution} />,
    },

    {
      key: "awards",
      label: "Awards",
      children: <AwardsTab institution={institution} />,
    },
  ];

  return (
    <>
      <PageHeading
        title="Institution Profile"
        subtitle1="Institution"
        subtitle2="Profile"
      />
      <div className="px-6 py-6">
        <div className="bg-white shadow-sm rounded-lg p-6">
          <h1 className="text-2xl font-bold mb-6">{institution.name}</h1>
          <Tabs
            defaultActiveKey="overview"
            type="card"
            size="middle"
            items={tabItems}
          />
        </div>
      </div>
    </>
  );
};

export default InstitutionProfile;
